<template>
  <section>
    <header class="header-image ken-burn-center light" data-parallax="true"
            data-natural-height="500" data-natural-width="1920" data-bleed="0"
            data-image-src="../media/header1_saj.jpg" data-offset="0">
      <div class="container">
        <h1>SAJ</h1>
        <h2>INVERSORES ON-GRID</h2>
      </div>
    </header>
    <main>
      <section class="section-base">
        <div class="container">
          <div class="row row-fit-lg">
            <div class="col-lg-12">
              <p align="justify">
                &nbsp;&nbsp;Priorizando a inovação técnica como o núcleo, SAJ domina tecnologias
                líderes, como a geração de energia fotovoltaica de alta eficácia e conservação de
                energia, monitoramento inteligente e operação e manutenção compartilhadas, para
                construir um ambiente de alta energia eficiente integrando geração de energia ,
                economia de energia e uso de energia.<br> Foi premiada como Empresa Nacional de Alta
                Tecnologia, Intertek "Laboratório de Satélite Autorizado", Empresa de Ciência e
                Tecnologia "Pequeno Gigante" de Guangzhou, Centro de Pesquisa Tecnológica e
                Engenharia de Inversores Solar de Guangdong, o 1º Certificado de Qualificação de
                Laboratório TÜV Rhein WMT e assim por diante. Até o momento, a empresa recebeu 22
                patentes de invenção, 59 patentes de modelo de utilidade, 17 patentes de design
                exterior, 42 direitos autorais de software e 6 produtos de software com
                registros.<br><br>

                &nbsp;&nbsp;A indústria fornece inversores on-grid e soluções de monitoramento,
                conversores de frequência geral, acionamento de bomba inteligente e sistema de
                bombeamento solar. A remessa total de conversor de frequência geral SAJ (<11kW) está
                entre os 5 primeiros no mercado. Enquanto isso, seus inversores solares SAJ foram
                premiados com a marca Top 10 de inversores solares na China por cinco anos
                consecutivos. A SAJ também é um parceiro cooperativo da State Grid Corporation of
                China em termos de estratégias de rede de nuvem fotovoltaica distribuída.<br><br>

                &nbsp;&nbsp;Com a estratégia de rede de serviço local, possui mais de 20 filiais e
                mais de 80 centros de serviço na China, e seu centro de serviço no exterior foi
                expandido para Alemanha, Bélgica, Turquia, Austrália, Índia, Brasil e outros países.
                Com qualidade superior e rede de serviço abrangente, a SAJ aplicou com sucesso 1
                milhão de conjuntos de produtos em todo o mundo.<br><br>

                &nbsp;&nbsp;Aderindo ao conceito de "integridade, aprendizado, inovação, cooperação
                ganha-ganha", a SAJ se dedica ao desenvolvimento da tecnologia líder em drive &
                zero-carbono e economia de energia, para se estabelecer como um provedor de serviços
                de gestão digital de energia de edifícios e para construir um ambiente de energia
                verde, inteligente e eficiente, para tornar a vida melhor, mais feliz e mais
                saudável.<br>
              </p>
              <img :src="require('Assets/images/photo_saj1.jpg')">
            </div>
          </div>
        </div>
      </section>
      <MarcasParceiras></MarcasParceiras>
      <br><br>
    </main>
  </section>
</template>

<script>
import MarcasParceiras from 'Homepage/common/MarcasParceiras.vue';

export default {
  name: 'Saj',
  components: {
    MarcasParceiras,
  },
};
</script>

<style scoped>
header {
  height: 250px !important;
  background-image: url("../../assets/images/header1_saj.jpg");
}
header .container {
  padding-top: 50px !important;
}
header h2 {
  color: #0098da !important;
  line-height: 37px;
  text-transform: uppercase !important;
  font-weight: 700 !important;
  margin: 0 !important;
  font-size: 14px !important;
}

</style>
